export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
export const GENERIC_NOTIFICATION = 'GENERIC_NOTIFICATION'

export function removeNotification(id) {
  return {
    type: REMOVE_NOTIFICATION,
    id,
  }
}

/**
 * @param {string} message
 * @param {'info' | 'success' | 'warning' | 'error' | 'default'} level
 * @param {string} id deduplication id
 * @returns
 */
export function genericNotification(message, level, id) {
  return dispatch => {
    dispatch({
      type: GENERIC_NOTIFICATION,
      message,
      level,
      id,
    })
  }
}
